import React from 'react';
import styled from 'styled-components';

import VideoContent from './VideoContent';
import ButtonArea from './ButtonArea';
import VideoPlayerTitle from './VideoTitle';
import VideoPlayerMetadata from './VideoMetadata';
import CreateDownloadDialog from '../ClipListPanel/CreateDownloadDialog/component';

const VideoPlayerPanelContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-right: 15px;
`;

export default function VideoPlayerPanel() {
  return (
    <VideoPlayerPanelContainer id="VideoPlayerPane">
      <VideoPlayerTitle />
      <VideoPlayerMetadata />
      <VideoContent />
      <ButtonArea />
      <CreateDownloadDialog />
    </VideoPlayerPanelContainer>
  );
}
